import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faUnlink } from '@fortawesome/pro-solid-svg-icons';

import ConnectionDetails from './connection_details';

export default class ConnectedRow extends React.Component {
  static propTypes = {
    connectableObject: PropTypes.shape({
      connections: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired
      })),
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }).isRequired,
    onLinkMore: PropTypes.func.isRequired,
    onUnlink: PropTypes.func.isRequired
  }

  renderDetails() {
    const { name, subtitle } = this.props.connectableObject;
    return <ConnectionDetails name={name} subtitle={subtitle}/>;
  }

  render() {
    const connectableObject = this.props.connectableObject;

    const links = connectableObject.connections.map((connection) => {
      return (
        <div key={connection.path}>
          <a href={connection.path}>{connection.databaseName} - {connection.name}</a>
          <span
            className='ml-2 text-muted clickable'
            name='unlink'
            onClick={() => this.props.onUnlink(connection.id, connectableObject.type, connectableObject.id)}
          >
            <FontAwesomeIcon icon={faUnlink}/>
          </span>
        </div>
      );
    });

    return (
      <Row key={connectableObject.id}>
        <Col lg={5} xs={5}>
          {this.renderDetails()}
        </Col>
        <Col lg={5} xs={4}>
          Linked To:
          {links}
        </Col>
        <Col className='text-right' xs={2}>
          <div
            className='text-primary clickable'
            name='linkMore'
            onClick={this.props.onLinkMore}
          >
            <FontAwesomeIcon className='mr-2' icon={faLink}/> Link More
          </div>
        </Col>
      </Row>
    );
  }
}
